import { Component, HostListener, inject } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { WhatsappModalComponent } from './components/whatsapp-modal.component';
import { WhatsappModalService } from './services/whatsapp-modal.service';
import { AttributionService } from './services/attribution.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, WhatsappModalComponent],
  template: `
    <router-outlet></router-outlet>
    <app-whatsapp-modal></app-whatsapp-modal>
  `
})
export class AppComponent {
  private router = inject(Router);
  whatsappModalService = inject(WhatsappModalService);
  private _attribution = inject(AttributionService);

  openWhatsapp(url: string) {
    this.whatsappModalService.open(url);
  }

  get isV3() {
    return this.router.url.includes('/v3');
  }

  get isObrigado() {
    return this.router.url.includes('/obrigado');
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({
        event: 'generate_lead',
        form_id: event.data.id
      });

      if (this.router.url.includes('/v2')) {
        this.router.navigate(['/v2/obrigado']);
      } else {
        this.router.navigate(['/obrigado']);
      }
    }
  }
}
